import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-terms-organisation',
  templateUrl: './terms-organisation.component.html',
  styleUrls: ['./terms-organisation.component.scss']
})
export class TermsOrganisationComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  gotoPrivacy() {
    this.router.navigateByUrl('privacy');
  }
}
